import React from 'react'
import styles from './InfoMessage.module.scss'
import Icon from '../Icon'
import { icons } from 'assets'
import { Props } from './types'
import cl from 'classnames'

const InfoMessageComponent = (props: Props) => {
  const {
    icon = icons.warningSign,
    message = 'No data to show.',
    className,
    style
  } = props

  return (
    <div className={cl(styles.info, className)} style={style}>
      <Icon
        icon={icon}
        className={styles.warningSign}
      />
      <div>
        {message}
      </div>
    </div>
  )
}

const InfoMessage = InfoMessageComponent
export { InfoMessage }
